import React, { Component } from 'react';
import Bird from './bird';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Bird/>
      </div>
    );
  }
}

export default App;
